import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastController } from '@ionic/angular';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { CommonFunction } from '../common-function';
import { ProjectConstants } from '../project-constants';
import { timer } from 'rxjs';
import { OtpDialogService } from './otp-dialog.service';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-otp-dialog',
  templateUrl: './otp-dialog.component.html',
  styleUrls: ['./otp-dialog.component.scss'],
})
export class OtpDialogComponent implements OnInit {
  otp: string;
  timeLeft: number = 300;
  interval;
  showOtp: string = "";
  progressSpinnerDialog: any = null;

  mobileOtp: any = "";
  constructor(public toastController: ToastController,
    public dialog: MatDialog,
    public commonFunction: CommonFunction,
    private dialogRef: MatDialogRef<OtpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public otpService: OtpDialogService) { }


  async validate() {
    this.displayProgressSpinner();
    const response: any = await this.otpService.verifyOtp(this.mobileOtp, this.data.id);
    this.progressSpinnerDialog.close()
    if (response.status == ProjectConstants.responseStatusSuccess) {
      this.dialogRef.close(ProjectConstants.dialogCloseYes);
    } else if (response.status == ProjectConstants.otpValidityExpired) {
      this.mobileOtp = ""
      this.timeLeft = 0;
      this.showOtp = ProjectConstants.otpValidityExpired
    } else if (response.status == ProjectConstants.responseStatusFailure) {
      if (response.message == ProjectConstants.otpInvalidStatus) {
        this.showOtp = ProjectConstants.otpInvalidStatusMsg
        this.mobileOtp = ""
      } else if (response.message == ProjectConstants.grievanceBackendTimeoutMsg) {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        this.dialogRef.close(ProjectConstants.noMsg);
      } else if (response.message == ProjectConstants.lotteryBackendTimeoutMsg) {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        this.dialogRef.close(ProjectConstants.noMsg);
      }
    }
  }



  ngOnInit() {
    //set timer for otp 5min=300sec
    // this.interval = setInterval(() => {
    //   if (this.timeLeft > 0) {
    //     this.timeLeft--;
    //   } else {
    //     this.timeLeft = 0;
    //   }
    // }, 1000)
    //




    const countdown$ = timer(0, 1000).pipe(
      take(300),
      map(secondsElapsed =>{      
        this.timeLeft=  300 - secondsElapsed
      })
    );

    countdown$.subscribe(secondsLeft => {
      var timeLeft  = secondsLeft;
    });

  }
  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  //resend otp
  async resendOtp() {
    this.displayProgressSpinner();
    this.mobileOtp="";
    this.showOtp="";
    const response: any = await this.otpService.resendOtp(this.data.id);
    this.progressSpinnerDialog.close()
    if (response.status == ProjectConstants.responseStatusSuccess) {
      await this.commonFunction.successToast(ProjectConstants.resendOtpSuccessToastMsg, false, "")

      this.timeLeft = 300
      // this.interval = setInterval(() => {
      //   if (this.timeLeft > 0) {
      //     this.timeLeft--;
      //   } else {
      //     this.timeLeft = 0;
      //   }
      // }, 1000)
      const countdown$ = timer(0, 1000).pipe(
        take(300),
        map(secondsElapsed =>{ 
          this.timeLeft= 300 - secondsElapsed
        })
           
      );
      countdown$.subscribe(secondsLeft => {     
        var timeLeft  = secondsLeft;
      });

    } else if (response.status == ProjectConstants.responseStatusFailure) {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }
  //
  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
